import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'
import {IParticularColor} from '@toolify/server/src/services/ColorService/types/IParticularColor'
import {getParticularColorBySeed} from '@toolify/client/src/modules/color/composables/getParticularColorBySeed'

export function getParticularColorByEntity(entity: IResponseEntity): IParticularColor {
  if(!entity?.entityId) {
    return null
  }
  return getParticularColorBySeed(`${entity.entityType}:${entity.entityId}`)
}
